/** Canonical action names shared by dashboard payloads and tests. */
export const aiWidgetActions = {
  conversationBalance: 'conversation-balance',
  churnRiskDistribution: 'churn-risk-distribution',
  customerEffortDistribution: 'customer-effort-distribution',
  customerEffortBreakdown: 'customer-effort-breakdown',
  frictionSignalsFrequency: 'friction-signals-frequency',
  dispositionChangeDistribution: 'disposition-change-distribution',
} as const;

export type AiWidgetActionKey = keyof typeof aiWidgetActions;
export type AiWidgetAction = (typeof aiWidgetActions)[AiWidgetActionKey];

/** Frontend aliases resolved by the component registry. */
export const aiWidgetAliases = {
  CONVERSATION_BALANCE: 'ConversationBalance',
  CUSTOMER_EFFORT: 'CustomerEffort',
  DISPOSITION_CHANGE: 'DispositionChange',
  FRICTION_SIGNALS: 'FrictionSignals',
  CHURN_RISK_DISTRIBUTION: 'ChurnRiskDistribution',
} as const;

export type AiWidgetAliasKey = keyof typeof aiWidgetAliases;
export type AiWidgetAlias = (typeof aiWidgetAliases)[AiWidgetAliasKey];

/** Expected action for each frontend alias. */
export const aiWidgetAliasToAction: Record<AiWidgetAlias, AiWidgetAction> = {
  [aiWidgetAliases.CONVERSATION_BALANCE]: aiWidgetActions.conversationBalance,
  [aiWidgetAliases.CUSTOMER_EFFORT]: aiWidgetActions.customerEffortBreakdown,
  [aiWidgetAliases.DISPOSITION_CHANGE]: aiWidgetActions.dispositionChangeDistribution,
  [aiWidgetAliases.FRICTION_SIGNALS]: aiWidgetActions.frictionSignalsFrequency,
  [aiWidgetAliases.CHURN_RISK_DISTRIBUTION]: aiWidgetActions.churnRiskDistribution,
};
